// Set just before the sign-out redirect to Cognito so the app renders a
// loading state instead of briefly mounting the sign-in page. Without this,
// clearing the session flips <Template> to <SignIn />, whose logo image
// request is then aborted by the redirect — flashing a broken image until the
// post-logout page load. This module-level flag resets on that full reload.
export const logoutState = { active: false }
